import { ScreenSizeType } from './types'

const ScreenSizeTypes: {
  [screenSize in ScreenSizeType]: number
} = {
  'BIG': Infinity,
  'MEDIUM': 1067,
  'SMALL': 767,
}

export default ScreenSizeTypes